import React from "react";
import { Page } from "../../components/Page";
import { Disconnection } from "../../components/Disconnection";

export interface DisconnectionPageProps {
  tabTitle: string;
}

export const DisconnectionPage: React.FC<DisconnectionPageProps> = ({
  tabTitle,
}) => {
  return (
    <Page tabTitle={tabTitle}>
      <Disconnection />
    </Page>
  );
};
